export const serveBasePath =
  process.env.REACT_APP_SERVER_BASE_PATH ?? "http://localhost:9000";
export const apiPath = `${serveBasePath}${
  process.env.REACT_APP_API_PATH ?? "/api"
}`;
